const CountryRoutes = {
  getCountries: 'countries',
  getCountriesByPlan: 'countries/available',
};

export default CountryRoutes